// export const API_URL = "API_URL_GOES_HERE";
// export const Server_URL = "http://localhost:3022";
export const Server_URL = "https://server.hlzoptics.com";

// export const sqlUser = "root";
// export const sqlPath = "localhost";
// export const sqlPassword = "hlz-88888888";
// export const sqlDatabase = "hlzdatabase";

// export const sqlUser = "hlzopti1_hlzdatabase";
// export const sqlPath = "localhost";
// export const sqlPassword = "hlz-88888888";
// export const sqlDatabase = "hlzopti1_hlzdatabase";
